import { MapTo } from '@adobe/aem-react-editable-components';
import ResourcesForYou, { ResourcesForYouEditConfig } from './ResourcesForYou';

export default MapTo('cob-corp-acquisition/components/creditonebank/resources-for-you')(ResourcesForYou, ResourcesForYouEditConfig);